import request from 'utils/request';

export default async function fetchRole(): Promise<any> {
  try {
    const { data: roles } = await request(`/lineDriveService/roles`, {
      method: 'GET'
    });

    return roles;
  } catch (error) {
    let errorMessage = 'Failed to do something exceptional';
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    console.log(errorMessage);
  }
}
